/**
 * The dashboard's route path. The dashboard is a workspace (ADR-0048: creating always
 * uses a column), so its URL carries the open cascade after `/`. The param only
 * matches a cascade's `type:id` first segment, so an unknown path such as `/foo` still
 * falls through to the catch-all 404 instead of landing here; a bare `(.*)` would rank
 * below that catch-all and take `/` with it.
 */
export const HOME_ROUTE_PATH = '/:cascade([^/]+:.*)?';

/** Is `path` the dashboard, with or without columns open? */
export const isHomePath = (path: string): boolean => path === '/' || /^\/[^/]+:/.test(path);
